const BalanceAlgo = ({ value }) => {
  return (
    <span className='flex items-center gap-2 text-current' title='$ALGO Balance'>
      <span className='bg-white rounded-full h-[25px] w-[25px]'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 650 650'>
          <g id='lINT7W'>
            <polygon points='444.18 444.32 406.81 444.32 382.54 354.04 330.36 444.33 288.64 444.33 369.29 304.57 356.31 256.05 247.56 444.36 205.82 444.36 343.64 205.64 380.18 205.64 396.18 264.95 433.88 264.95 408.14 309.71 444.18 444.32' />
          </g>
        </svg>
      </span>
      <span className='text-base font-semibold tabular-nums'>{value}</span>
    </span>
  );
};

export default BalanceAlgo;
